/**
 * Reducer for fee related data (which is selected, fee types, fee amounts etc).
 */

import { ActionTypes as types } from '../constants'

// Initial state. Immutable.
const initialState = {
  feeAmountBank: '0.00',
  feeAmountCard: '0.00',
  feeAmountDebit: '0.00',
}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 *
 */
export default function fee(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVED_FEE:
      return {
        ...state,
        feeAmountBank: action.data.bank.fee,
        feeAmountCard: action.data.card.fee,
        feeAmountDebit: action.data.debit.fee,
      }

    default:
      return state
  }
}
